import { useEffect, useState } from 'react'
import { StorageService } from '../services/storage'
import { STORAGE } from '../constants'
import { useNavigate } from 'react-router-dom';

export default function usePeriod() {
  const navigate = useNavigate();
  
  const [currentPeriod, setCurrentPeriod] = useState(StorageService.get(STORAGE.PERIOD) || { _id: null, name: null})

  useEffect(() => {
    if(!currentPeriod ||  !currentPeriod._id) {
      navigate('/select-period');
    }
  }, [currentPeriod])
  
  
  return {
    currentPeriod
  }
}
